<iframe
  src="https://cubo-demos.com.ar/test-tienda.html"
  style="width: 400 px; height: 400px"
  frameborder="0"
></iframe>

<!--  sandbox="allow-forms allow-scripts"-->
